import React, { createContext, useContext } from 'react';

interface JobListingContextType {
  headerData: {
    poster_image?: string | null;
    video_webm?: string | null;
    video_mp4?: string | null;
  };
  homeUrl: string;
}

const JobListingContext = createContext<JobListingContextType>({});

export const useJobListingContext = () => useContext(JobListingContext);

export const JobListingProvider: React.FC<{ value: JobListingContextType, children: React.ReactNode }> = ({ value, children }) => (
  <JobListingContext.Provider value={value}>
    {children}
  </JobListingContext.Provider>
);
